<template>
    <div class="home">
        <GlitchH1 :glitch="glitch1">Erikdevelop.com</GlitchH1>
        <GlitchP :glitch="glitch2">Under construction...</GlitchP>
        <GlitchP :glitch="glitch3">
            even in the sunnier world of vue, rewriting your entire codebase
            isn't out of the question because an NPM package decided to shit the
            bed...
        </GlitchP>
        <GlitchP :glitch="glitch4"
            >Besides, I learned, and got better...</GlitchP
        >
        <GlitchP :glitch="glitch5">
            Nope, never mind, Vue comes with 4 critical vulnerabilities out of
            the box.
        </GlitchP>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { GlitchH1, GlitchP } from "@/ui/atoms";
@Options({
    components: {
        GlitchH1,
        GlitchP,
    },
})
export default class HomeView extends Vue {
    glitch1 = false;
    glitch2 = false;
    glitch3 = false;
    glitch4 = false;
    glitch5 = false;

    mounted() {
        const randomCountdownTimer =
            Math.floor(Math.random() * (10 - 5 + 1) + 5) * 1000;

        const initialTimeout = setTimeout(() => {
            this.glitch1 = true;
            clearTimeout(initialTimeout);

            const animationTimeout = setTimeout(() => {
                this.glitch1 = false;
                this.randomGlitches();
                clearTimeout(animationTimeout);
            }, 2000);
        }, randomCountdownTimer);
    }

    randomGlitches() {
        const randomCountdownTimer =
            Math.floor(Math.random() * (5 - 2 + 1) + 2) * 1000;

        const randomAmountOfLines = Math.floor(Math.random() * (5 - 1 + 1) + 1);

        const randomTimeout = setTimeout(() => {
            this.activateRandomGlitches(randomAmountOfLines);

            const animationTimeout = setTimeout(() => {
                this.deactivateAllGlitches();
                this.randomGlitches();
                clearTimeout(animationTimeout);
            }, 2000);

            clearTimeout(randomTimeout);
        }, randomCountdownTimer);
    }

    activateRandomGlitches(amount: number) {
        for (let i = 0; i < amount; ++i) {
            let keepsearching = true;
            while (keepsearching) {
                const randomGlitch = Math.floor(
                    Math.random() * (5 - 1 + 1) + 1
                );

                if (!this.isGlitchActive(randomGlitch)) {
                    this.activateGlitch(randomGlitch);
                    keepsearching = false;
                }
            }
        }
    }

    isGlitchActive(index: number) {
        if (index === 1) return this.glitch1;
        if (index === 2) return this.glitch2;
        if (index === 3) return this.glitch3;
        if (index === 4) return this.glitch4;
        if (index === 5) return this.glitch5;
    }

    activateGlitch(index: number) {
        if (index === 1) this.glitch1 = true;
        if (index === 2) this.glitch2 = true;
        if (index === 3) this.glitch3 = true;
        if (index === 4) this.glitch4 = true;
        if (index === 5) this.glitch5 = true;
    }

    deactivateAllGlitches() {
        this.glitch1 = false;
        this.glitch2 = false;
        this.glitch3 = false;
        this.glitch4 = false;
        this.glitch5 = false;
    }
}
</script>

<style scoped>
.home {
    padding: 10px;
}
</style>
